type Target = "_blank" | "_self";
export const redirectWithoutRouter = (url: string, target: Target): void => {
  window.open(url, target);
};
